import React from 'react';
import {useQuery} from '@apollo/client';
import PropTypes from 'prop-types';
import {get as _get} from 'lodash';
import {connect} from 'react-redux';

import HeaderRenderer from '@appComponents/HeaderRenderer';
import {exportExcel} from '@modules/sequenceConfig/utils/export/sequencesExcel';
import {SequenceConfigTable} from '@modules/sequenceConfig/components/Table/SequenceConfigTable';
import {SequenceConfigButtons} from '@modules/sequenceConfig/components/SequenceConfigButtons';
import SequenceConfigFilters from '@modules/sequenceConfig/components/SequenceConfigFilters';
import {GetSequencesForTable} from '@graphql/sequence/query';
import {FilterQueryWrapper} from '@appComponents/HOCFiltersQueryWrapper';
import {getSearchFilters} from '@utils/filters';

export const SequenceConfigIndex = (props) => {
    const {data, loading} = useQuery(GetSequencesForTable, {
        variables: {search: props.filters.search ?? null},
        fetchPolicy: 'no-cache',
    });
    const sequences = _get(data, 'sequences', []);

    return <>
        <HeaderRenderer
            buttons={SequenceConfigButtons}
            exportExcelParams={exportExcel(sequences)}
            filters={SequenceConfigFilters}
            filtersButtonName='SequenceConfig'
            filtersProps={{loading}}
            loading={loading}
            messagesBoxNames='sequenceMessage'
            pageTitle='Sequence configs'
        />
        <SequenceConfigTable
            loading={loading}
            sequences={sequences}
        />
    </>;
};

SequenceConfigIndex.propTypes = {
    filters: PropTypes.object.isRequired,
};

const SequenceConfigIndexWrapped = FilterQueryWrapper(SequenceConfigIndex, {
    queryForRefetch: GetSequencesForTable,
    filterUrls: ['sequenceConfigs.index'],
});

const mapStateToProps = (state) => ({
    filters: getSearchFilters(state, 'SequenceConfig', {search: null}),
});

export default connect(mapStateToProps)(SequenceConfigIndexWrapped);
